import { Box, Stack, SxProps, Theme, styled } from '@mui/material';
import cx from 'classnames';
import { LocaleContext } from 'new/i18n/LocaleContext';
import { useContext } from 'react';

const LanguageToggleWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  gap: theme.spacing(0.5),
  '.language': {
    cursor: 'pointer',
  },
  '.language, .separator': {
    cursor: 'pointer',
    fontSize: '0.875rem',
  },
  '.language.active': {
    fontWeight: 'bold',
  },
}));

type Props = {
  sx?: SxProps<Theme>;
};

const LanguageToggle: React.FC<Props> = ({ sx }) => {
  const { locale, setLocale } = useContext(LocaleContext);
  return (
    <LanguageToggleWrapper mt={1} sx={sx}>
      <Box
        className={cx('language', {
          active: locale === 'en-US',
        })}
        onClick={() => setLocale('en-US')}
      >
        English
      </Box>
      <Box className="separator">|</Box>
      <Box
        className={cx('language', {
          active: locale === 'es-US',
        })}
        onClick={() => setLocale('es-US')}
      >
        Español
      </Box>
    </LanguageToggleWrapper>
  );
};

export default LanguageToggle;
